import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Architecture Modernization by Nick Tune"
        desc="Socio-technical alignment of software, strategy, and teams"
        keyword="architecture modernization, nick tune, domain-driven design, legacy systems, socio-technical"
        image="/images/books/architecture-modernization.jpg"
        pageType="book"
        author="Nick Tune"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/architecture-modernization.jpg"
                alt="architecture modernization nick tune engineering book"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Architecture Modernization
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Nick Tune</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Nick Tune tackles the challenge that nearly every growing organization faces:
                how to modernize a legacy architecture without stopping the world. The book
                goes beyond just technical strategies, emphasizing the socio-technical approach —
                aligning software architecture with business domains, team boundaries, and
                organizational strategy.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Drawing on domain-driven design, wardley mapping, and event storming, Tune
                provides a practical playbook for assessing your current architecture, building
                a modernization strategy, and executing incrementally. If you've ever struggled
                with migrating a monolith, untangling coupled services, or getting stakeholder
                buy-in for architectural change, this book offers the frameworks and case studies
                to guide the way.
              </p>
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
